import { IExpandedMailingRule } from 'interfaces/MailingRule';
import { IMailingRuleParsedToStrategyActionsItem } from 'interfaces/Strategy';

const parsedAggregrationType = {
  contract: 'Nível Contrato',
  customer: 'Nível Cliente',
};

const parsedSegmentType = {
  INTERCOMPANY: 'Intercompany',
  ATACADO: 'Atacado',
  CORPORATIVO: 'Corporativo',
  EMPTY: 'Empresarial',
  PF: 'Pessoa Física',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getEPSListNames = (selectedEPS: any) => {
  const selectedEPSKeys = Object.keys(selectedEPS);

  return selectedEPSKeys.map((k, index) => ({
    _id: index.toString(),
    description: selectedEPS[k].epsId.fantasyName || 'Erro',
  }));
};

const getSegmentNames = (corporateType: string[], customerType: string[]) => {
  const corporateNamesFormated = Object.assign(corporateType, customerType)
    .map((item) => {
      return parsedSegmentType[item];
    })
    .filter((el) => el !== undefined)
    .join(', ');
  return corporateNamesFormated;
};

export const parsedMailingRuleToStrategyItem = (
  mailingRule: IExpandedMailingRule,
): IMailingRuleParsedToStrategyActionsItem => {
  const activation = false;
  const priority = 0;
  return {
    id: mailingRule._id || mailingRule.id,
    activation,
    priority,
    mailingRuleName: mailingRule.name,
    epsList: getEPSListNames(mailingRule.selectedEPS),
    distributionKey:
      parsedAggregrationType[mailingRule.aggregationType.toLocaleLowerCase()],
    segment: getSegmentNames(
      mailingRule.corporateType,
      mailingRule.customerType,
    ),
    contractDelay:
      mailingRule.contractAging?.min && mailingRule.contractAging?.max
        ? `De ${mailingRule.contractAging?.min} até ${mailingRule.contractAging?.max} dias`
        : 'Todos',
  };
};
